export default __webpack_public_path__ + "static/media/background.ab778124.jpg";